const Marker = ({ classname, width = '48', height = '40' }) => (
  <svg
    className={classname}
    width={width}
    height={height}
    viewBox="0 0 48 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 9.11429C24.5 10.2539 24.0425 11.6033 23.3063 13.0208C22.575 14.4288 21.5941 15.8562 20.6041 17.1393C19.6154 18.4208 18.6255 19.5483 17.8821 20.3558C17.5189 20.7505 17.2151 21.068 17 21.2891C16.7849 21.068 16.4811 20.7505 16.1179 20.3558C15.3745 19.5483 14.3846 18.4208 13.3959 17.1393C12.4059 15.8562 11.425 14.4288 10.6937 13.0208C9.95749 11.6033 9.5 10.2539 9.5 9.11429C9.5 4.2935 12.9171 0.5 17 0.5C21.0829 0.5 24.5 4.2935 24.5 9.11429Z"
      fill="#F9F9F9"
      stroke="#3C3C3B"
    />
    <circle cx="17" cy="8" r="3.5" fill="#F9F9F9" stroke="#3C3C3B" />
  </svg>
);

export default Marker;
